import { useLoaderData, useNavigate } from "react-router-dom";
import { News } from "./News";
import { useState } from "react";
import { convertToRaw, convertFromRaw, EditorState } from "draft-js";
import { Button, Form } from "react-bootstrap";
import { Editor } from "react-draft-wysiwyg";
import DatePicker from "react-datepicker";

export async function NewsLoader({ params }: any): Promise<Event | undefined> {
	const newsId = params.newsId;
	console.log(newsId);

	const res = await fetch(`${process.env.REACT_APP_API_URL}/news`, {
		method: 'GET',
		headers: {
			'Content-Type': 'application/json',
		},
	});

	const data = await res.json();

	if (!res.ok) {
		console.error(data.message);
		throw new Error(data.message);
	}

	for (const newsPost of data) {
		if (newsPost.id === newsId) {
			return newsPost;
		}
	}
}

export function NewsEdit() {
	const navigation = useNavigate();
	const newsPost: News = useLoaderData() as News;

	console.log(newsPost.content);
	console.log(convertFromRaw(newsPost.content));
	console.log(convertFromRaw(newsPost.content).getPlainText());

	const [editorState, setEditorState] = useState<EditorState>(EditorState.createWithContent(convertFromRaw(newsPost.content)));
	const [title, setTitle] = useState(newsPost.title);
	const [publishDate, setPublishDate] = useState(new Date(new Date(newsPost.publishAt).setSeconds(0, 0)));
	const [publishNow, setPublishNow] = useState(false);
	const [enableImage, setEnableImage] = useState(newsPost.imageUrl !== null);
	const [image, setImage] = useState(newsPost.imageUrl);
	const [file, setFile] = useState<File | undefined>(undefined);

	function onEditorStateChange(editorState: EditorState) {
		setEditorState(editorState);
	}

	async function onFileChange(e: React.ChangeEvent<HTMLInputElement>) {
		const file = e.target.files?.[0];
		setFile(file);
		if (!file) return;
		console.log(file);

		const res = await fetch(`${process.env.REACT_APP_API_URL}/presignedUrl`);
		const data = await res.json();

		const signedUrl = data.signedUrl;
		const imageUrl = data.imageUrl;

		await fetch(signedUrl, {
			method: 'PUT',
			body: file,
		});

		setImage(imageUrl);
	}

	function formSubmit(e: React.FormEvent<HTMLFormElement>) {
		e.preventDefault();
		onSubmit();
	}

	async function onSubmit() {
		const json = {
			title,
			publishAt: publishNow ? undefined : publishDate.toString(),
			content: convertToRaw(editorState.getCurrentContent()),
			imageUrl: enableImage ? image : undefined,
		};
		const res = await fetch(`${process.env.REACT_APP_API_URL}/news/${newsPost.id}`, {
			method: 'PUT',
			headers: {
				'Content-Type': 'application/json',
			},
			body: JSON.stringify(json),
		});
		const data = await res.json();
		console.log(data);

		if (res.ok) {
			navigation('/news');
		} else {
			alert(data.message);
		}
	}

	return (
		<div className="container container-lg">
			<h1>Edit News Post</h1>
			<Form onSubmit={formSubmit}>
				<Form.Group controlId="title" className="mb-3">
					<Form.Label>Title</Form.Label>
					<Form.Control type="text" placeholder="Enter title" value={title} onChange={e => setTitle(e.target.value)} />
				</Form.Group>
				<Editor
					editorState={editorState}
					toolbarClassName="toolbarClassName"
					wrapperClassName="wrapperClassName"
					editorClassName="editorClassName"
					onEditorStateChange={onEditorStateChange}
					wrapperStyle={{ border: "1px solid black", borderRadius: 5, padding: "5px" }}
				/>
				<Form.Group controlId="publishDate" className="mb-3" style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
					<Form.Label>Publish Time</Form.Label>
					<Form.Check
						type={'checkbox'}
						label={`Publish Now`}
						checked={publishNow}
						onChange={(e) => setPublishNow(e.target.checked)}
					/>
					{!publishNow && <Form.Control as={DatePicker}
						selected={publishDate}
						onChange={(date: unknown) => setPublishDate(new Date(date as Date))}
						showTimeInput
						dateFormat="Pp"
						required
						inline />}
				</Form.Group>
				<Form.Group controlId="image" className="mb-3" style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
					<Form.Label>Image</Form.Label>
					<Form.Check
						type={'checkbox'}
						label={`Include Image`}
						checked={enableImage}
						onChange={(e) => setEnableImage(e.target.checked)}
					/>
					{enableImage && <img width={400} src={image} alt="" />}
					{enableImage && <Form.Control type="file" onChange={onFileChange} />}
				</Form.Group>
				<Button variant="primary" type="submit">
					Save
				</Button>
			</Form>
		</div>
	);
}
